var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThinkology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 952,
    height: 952,
    viewBox: "0 0 952 952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_338",
    "data-name": "Rectangle 338",
    width: 952,
    height: 952,
    transform: "translate(0 0)",
    fill: "#f2485f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M949.5,497.316V452.2H813.183a404.657,404.657,0,0,0-48.951-72.94l157.761-65.342-17.259-41.678-173.835,72a383.217,383.217,0,0,0-52.762-40.979L826.4,155l-31.892-31.892L637.221,280.393a374.07,374.07,0,0,0-49.431-19.585L677.271,44.771,635.593,27.512l-92.038,222.2A377.166,377.166,0,0,0,497.3,244.1V0H452.2V244.1a377.166,377.166,0,0,0-46.25,5.607l-92.038-222.2L272.229,44.771,361.71,260.808a374.058,374.058,0,0,0-49.431,19.585L154.992,123.112,123.1,155,271.362,303.265A383.2,383.2,0,0,0,218.6,344.245l-173.835-72L27.507,313.919l157.761,65.342a404.662,404.662,0,0,0-48.951,72.94H0v45.115H136.324a404.744,404.744,0,0,0,48.945,72.94L27.507,635.6l17.259,41.672,173.841-72a383.235,383.235,0,0,0,52.756,40.979L123.1,794.507l31.892,31.9L312.279,669.117a372.964,372.964,0,0,0,49.437,19.592L272.229,904.74,313.907,922,405.946,699.8a374.616,374.616,0,0,0,46.25,5.608v244.1H497.3v-244.1a374.619,374.619,0,0,0,46.25-5.608L635.593,922l41.678-17.265L587.783,688.709a373.3,373.3,0,0,0,49.437-19.592L794.508,826.4l31.892-31.9L678.138,646.251a383.257,383.257,0,0,0,52.756-40.979l173.841,72L921.993,635.6,764.232,570.255a404.438,404.438,0,0,0,48.951-72.94ZM474.75,661.021c-125.938,0-239.67-71.081-299.318-186.26C235.08,359.57,348.812,288.489,474.75,288.489S714.42,359.57,774.068,474.761C714.42,589.94,600.682,661.021,474.75,661.021",
    transform: "translate(0.034 0.98)",
    fill: "#f2485f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M177.661,56.94A121.02,121.02,0,1,0,298.678,177.957,121.021,121.021,0,0,0,177.661,56.94",
    transform: "translate(296.699 299.2)",
    fill: "#f2485f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkology);
export default __webpack_public_path__ + "static/media/thinkology.1dace3e28e7e0a01babb5bac0f9876df.svg";
export { ForwardRef as ReactComponent };